import { useSearchParams as _useSearchParams } from 'react-router-dom'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

const useSearchParams = <T = Record<string, unknown>>(): T => {
  const [_params] = _useSearchParams()

  const params = useUnsafeMemo(() => {
    const keys = Array.from(_params.keys())

    return keys.reduce((acc, x) => {
      const value = _params.get(x)

      if (!value) return acc

      try {
        return { ...acc, [x]: JSON.parse(value) }
      } catch (error) {
        return { ...acc, [x]: value }
      }
    }, {})
  }, [_params])

  return params as T
}

export default useSearchParams
